import React, {useState} from 'react';
import {useDispatch, useSelector} from "react-redux";

import styles from './AddedPhotosCompletedWork.module.scss';
import {resolveMediaUrl} from "../../configs/urls";
import ModalPreviewSelectedPhoto from "../ModalPreviewSelectedPhoto/ModalPreviewSelectedPhoto";
import {modalPreviewSelectedPhotoActions} from "../../store/slices/modalPreviewSelectedPhotoSlice";

const AddedPhotosCompletedWork = ({cleanerPhotos, clientPhotos}) => {
    const [selectedOption, setSelectedOption] = useState(cleanerPhotos?.length > 0 ? 'Клінер' : 'Замовник');
    const [photoForPreview, setPhotoForPreview] = useState(null);

    const dispatch = useDispatch();

    const {isPreviewOpen} = useSelector(state => state.modalPreviewSelectedPhoto);

    const handleSelectPhotoForPreview = (file) => {
        dispatch(modalPreviewSelectedPhotoActions.openPreview('AddedPhotosCompletedWork'));

        setPhotoForPreview(file);
    };

    const handleSelectOption = (option) => {
        if (option === 'Замовник') {
            if (clientPhotos?.length > 0) {
                setSelectedOption(option);
            }
        } else {
            if (cleanerPhotos?.length > 0) {
                setSelectedOption(option);
            }
        }
    }

    return (
        <div className={styles.addedPhotosCompletedWork}>
            <h3 className={styles.addedPhotosCompletedWork_title}>Фото виконаної роботи</h3>
            <ul className={styles.addedPhotosCompletedWork_options}>
                <li
                    className={`
                     ${selectedOption === 'Клінер' ? styles.active : ''}
                     ${cleanerPhotos?.length === 0 ? styles.disabled : ''}
                     `}
                    onClick={() => handleSelectOption('Клінер')}
                >Клінер
                </li>
                <li
                    className={`
                    ${selectedOption === 'Замовник' ? styles.active : ''} 
                    ${clientPhotos?.length === 0 ? styles.disabled : ''}
                    `}
                    onClick={() => handleSelectOption('Замовник')}
                >Замовник
                </li>
            </ul>

            {(selectedOption === 'Замовник' && clientPhotos?.length > 0) &&
                <div className={styles.addedPhotosCompletedWork_photos}>
                    {
                        clientPhotos?.map((file, index) =>
                            <div
                                onClick={() => handleSelectPhotoForPreview(file)}
                                key={index}
                                style={{backgroundImage: `url(${resolveMediaUrl(file)})`}}
                            ></div>)
                    }
                </div>}

            {(selectedOption === 'Клінер' && cleanerPhotos?.length > 0) &&
                <div className={styles.addedPhotosCompletedWork_photos}>
                    {
                        cleanerPhotos?.map((file, index) =>
                            <div
                                onClick={() => handleSelectPhotoForPreview(file)}
                                key={index}
                                style={{backgroundImage: `url(${resolveMediaUrl(file)})`}}
                            ></div>)
                    }
                </div>}

            {isPreviewOpen &&
                <ModalPreviewSelectedPhoto
                    photo={resolveMediaUrl(photoForPreview)}
                    component={'AddedPhotosCompletedWork'}
                />}
        </div>
    );
};

export default AddedPhotosCompletedWork;
